import { css, jsx } from '@emotion/core';
import { Input, Select } from 'antd';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import Form from '@/src/shared/components/Form';
import { handleFormChange } from '@/src/updateProfile/redux/actions';
import { bp, colors } from '@/styles';

const { Option } = Select;

const styles = {
  inputContainer: css`
    width: 100%;
    margin: 1.6rem 0;
    @media ${bp.md} {
      max-width: 36.5rem;
    }
    .ant-input {
      border: 1px solid ${colors.accentGrayMedium};
      background-color: ${colors.white};
    }
  `,
  selectContainer: css`
    width: 100%;
    margin: 1.6rem 0;
    @media ${bp.md} {
      max-width: 36.5rem;
    }
  `,
  select: css`
    width: 100%;
    .ant-select-selection {
      border: 1px solid ${colors.accentGrayMedium};
      background-color: ${colors.white};
    }
  `,
};

const OfficeState = props => {
  const { form, info, updateProfile, step, currentInfo, key, onChange } = props;
  const {
    label,
    persist,
    meta,
    field,
    formOverrides = {},
    options = [],
    optionId,
    optionDesc,
  } = info;
  const { isOtherOfficeStateVisible } = updateProfile;

  const countryChange = e => {
    if (e === 'Other') {
      props.handleFormChange('isOtherOfficeStateVisible', true);
    } else {
      props.handleFormChange('isOtherOfficeStateVisible', false);
    }
  };

  useEffect(() => {
    if (updateProfile.StateCode === 'Other') {
      props.handleFormChange('isOtherOfficeStateVisible', true);
    }
  }, []);

  return (
    <>
      <div key={optionId} css={styles.selectContainer}>
        <Form.Item label="State">
          {form.getFieldDecorator('StateCode', {
            initialValue: updateProfile['StateCode'],
            rules: [{ required: true, message: 'Select State.' }],
          })(
            <Select
              showSearch
              allowClear
              optionFilterProp="children"
              onChange={e => {
                countryChange(e);
                onChange('StateCode', e);
              }}
              css={styles.select}
              size="large"
              placeholder="Select"
            >
              {options.map(option => (
                <Option key={`Office-StateCode-${optionId}`} value={option[optionId]}>
                  {option[optionDesc]}
                </Option>
              ))}
            </Select>
          )}
        </Form.Item>
      </div>
      {isOtherOfficeStateVisible && (
        <div key={key} css={styles.inputContainer}>
          <Form.Item label="State/Region/Province">
            {form.getFieldDecorator('OfficeStateOther', {
              initialValue: '',
              rules: [{ required: true, message: 'Enter State/Region/Province.' }],
            })(
              <Input
                size="large"
                onChange={e => {
                  onChange('OfficeStateOther', e);
                }}
              />
            )}
          </Form.Item>
        </div>
      )}
    </>
  );
};

const mapStateToProps = ({ updateProfile }) => {
  return {
    updateProfile,
  };
};

export default connect(
  mapStateToProps,
  { handleFormChange }
)(OfficeState);
